/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Usage_ColInputs */

const en_admin_invite_codes_usage_col = /** @type {(inputs: Admin_Invite_Codes_Usage_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usage`)
};

/**
* | output |
* | --- |
* | "Usage" |
*
* @param {Admin_Invite_Codes_Usage_ColInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_usage_col = /** @type {((inputs?: Admin_Invite_Codes_Usage_ColInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Usage_ColInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_invite_codes_usage_col(inputs)
});
export { admin_invite_codes_usage_col as "admin.invite_codes.usage_col" }